export const INFO_SIGN = 'ⓘ';
